import palette from "../../styles/palette";

export default {
    title: {
        marginTop: 0,
        color: palette.text.primary,
    } as React.CSSProperties,
    treePanel: {
        zIndex: 9999,
        position: "absolute",
        left: 0, top: 0, bottom: 0, width: 500,
        borderRight: "solid 1px #eee",
        backgroundColor: "white"
    } as React.CSSProperties,
    treePanelSmallDevice: {
        backgroundColor: "white",
        zIndex: 9999,
        position: "absolute",
        left: 0, top: 0, bottom: 0, right: 0, width: "100%",
        borderRight: "solid 1px #eee"
    } as React.CSSProperties,

    locationDetailPanel: {
        position: "absolute",
        left: 500,
        overflowX: "hidden",
        overflowY: "hidden",
        top: 0,
        right: 0,
    } as React.CSSProperties,

    locationDetailPanelSmallDevice: {
        display: "none"
    } as React.CSSProperties,
    locationDetailPanelInner: {
        padding: 20
    } as React.CSSProperties,
    locationDetailPanelInnerCondensed: {
        backgroundColor: "#F5F5F5",
        paddingTop: 20,
        paddingBottom: 0,
    } as React.CSSProperties,
    toolBar: {
        borderBottom: "solid 1px #eee",
    } as React.CSSProperties,
    noData: {
        border: "solid 1px #eee",
        background: "#F8F8FD",
        padding: 20,
        marginTop: 20,
        textAlign: "center"
    } as React.CSSProperties,
    noDataCondensed: {
        width: "auto",
        border: "solid 1px #eee",
        background: "#F8F8FD",
        padding: 20,
        textAlign: "center"
    } as React.CSSProperties,
    condensedViewTabContainer: { 
        display: "flex",
        backgroundColor: "#F5F5F5",
        width: "100%", 
        paddingBottom: 0,
    } as React.CSSProperties,
    condensedViewTabs: {
        alignItems: "center",
        backgroundColor: "#F5F5F5",
        width: "auto", 
        fontWeight: "bold", 
        borderTopLeftRadius: 5, 
        borderTopRightRadius: 5, 
        paddingBottom: 0,
    }
}
